export type VehicleColorOption = {label: string; value: string};

/** Common vehicle paint colors; `value` is sent to the API (title case). */
export const VEHICLE_COLOR_OPTIONS: VehicleColorOption[] = [
  {label: "Beige", value: "Beige"},
  {label: "Black", value: "Black"},
  {label: "Blue", value: "Blue"},
  {label: "Bronze", value: "Bronze"},
  {label: "Brown", value: "Brown"},
  {label: "Burgundy", value: "Burgundy"},
  {label: "Champagne", value: "Champagne"},
  {label: "Charcoal", value: "Charcoal"},
  {label: "Copper", value: "Copper"},
  {label: "Cream", value: "Cream"},
  {label: "Gold", value: "Gold"},
  {label: "Gray", value: "Gray"},
  {label: "Green", value: "Green"},
  {label: "Grey", value: "Grey"},
  {label: "Ivory", value: "Ivory"},
  {label: "Maroon", value: "Maroon"},
  {label: "Navy", value: "Navy"},
  {label: "Navy Blue", value: "Navy Blue"},
  {label: "Orange", value: "Orange"},
  {label: "Pearl", value: "Pearl"},
  {label: "Pink", value: "Pink"},
  {label: "Purple", value: "Purple"},
  {label: "Red", value: "Red"},
  {label: "Silver", value: "Silver"},
  {label: "Tan", value: "Tan"},
  {label: "Teal", value: "Teal"},
  {label: "White", value: "White"},
  {label: "Yellow", value: "Yellow"},
].sort((a, b) => a.label.localeCompare(b.label));

/** Match API / form text to a canonical list option (case-insensitive), or null if unknown. */
export function findVehicleColorOption(raw: string | undefined | null): VehicleColorOption | null {
  const t = raw?.trim();
  if (!t) return null;
  return (
    VEHICLE_COLOR_OPTIONS.find((o) => o.value.toLowerCase() === t.toLowerCase()) ?? null
  );
}
